/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { MenuGroupMinWidth } from '@jira/navigation-apps__constants/src/MenuGroupMinWidth.tsx';
import SkeletonItem from '@atlaskit/menu/skeleton-item';
import MenuGroup from '@atlaskit/menu/menu-group';
import Section from '@atlaskit/menu/section';
import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';
import Flex from '@atlaskit/primitives/components/flex';
import { token } from '@atlaskit/tokens';

export const Skeleton = (): React.JSX.Element => (
	<Box xcss={wrapperStyles}>
		<MenuGroup minWidth={MenuGroupMinWidth}>
			<Section isList>
				<SkeletonItem hasIcon />
				<SkeletonItem hasIcon />
				<SkeletonItem hasIcon />
			</Section>
			<Section isList hasSeparator>
				<SkeletonItem hasIcon />
			</Section>
			<Flex>
				<Box xcss={projectTileSkeleton} />
			</Flex>
		</MenuGroup>
	</Box>
);

const wrapperStyles = xcss({
	boxSizing: 'border-box',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	inlineSize: `${MenuGroupMinWidth}px`,
});

const projectTileSkeleton = xcss({
	backgroundColor: 'color.skeleton',
	height: token('space.600'),
	flex: 1,
});
